import axios from "axios";
import { BASE_URL } from "./connections";

export const getDataRoles2 = async () => {
  let rutas = JSON.parse(sessionStorage.getItem("RUTAS"));
  let response = '';

  const endPoint = "roles2";
  const user = sessionStorage.getItem("VALOREM_APP");
  const rol = rutas[rutas.length - 1].rol;
  const tenant = "VAL";
  const level = rutas[rutas.length - 1].level;

  const url = `${BASE_URL}${endPoint}?user=${user}&rol=${rol}&tenant=${tenant}&level=${level}`;

  if(!sessionStorage.getItem(`${new Date().toLocaleDateString()}_${user}_${rol}_${tenant}_${level}`)){
    const result = await axios.get(url);
    response = result.data;
    sessionStorage.setItem(`${new Date().toLocaleDateString()}_${user}_${rol}_${tenant}_${level}`, JSON.stringify(response));
  } else {
    response = JSON.parse(sessionStorage.getItem(`${new Date().toLocaleDateString()}_${user}_${rol}_${tenant}_${level}`));
  }

  return response;
};
